<template>
  <span>
    <v-navigation-drawer
      app
      v-model="drawer"
      class="blue lighten-3"
      dark
      disable-resize-watcher
    >
      <v-list>
        <template v-for="(item, index) in items">
          <v-list-item :key="index">
            <router-link :to="item.to">
              <v-list-item-content :to="item.to">
                {{ item.title }}
              </v-list-item-content>
            </router-link>
          </v-list-item>
          <v-divider :key="`divider-${index}`"></v-divider>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="blue darken-1" dark>
      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-spacer class="hidden-md-and-up"></v-spacer>
      <router-link to="/">
        <v-toolbar-title class="title" to="/">{{ appTitle }}</v-toolbar-title>
      </router-link>
      <v-btn tile text class="hidden-sm-and-down ml-5" to="/services">
        Services
      </v-btn>
      <v-btn tile text class="hidden-sm-and-down" to="/contact">
        Contact us
      </v-btn>
      <v-btn tile text class="hidden-sm-and-down" to="/about">About us</v-btn>
      <v-spacer class="hidden-sm-and-down"></v-spacer>
      <v-btn tile text class="hidden-sm-and-down">SIGN IN</v-btn>
    </v-app-bar>
  </span>
</template>

<script>
export default {
  name: 'AppNavigation',
  data() {
    return {
      appTitle: 'Shahrmin Co',
      drawer: false,
      items: [
        { title: 'Home', to: '/' },
        { title: 'Services', to: '/services' },
        { title: 'Contact us', to: '/contact' },
        { title: 'About us', to: '/about' }
      ]
    }
  }
}
</script>

<style scoped>
a {
  color: white !important;
  text-decoration: none;
}
</style>
